import { render, staticRenderFns } from "./ForumThreadBox.vue?vue&type=template&id=1223e657&"
import script from "./ForumThreadBox.vue?vue&type=script&lang=js&"
export * from "./ForumThreadBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports